import {
  COLLABORATORS_PATHS,
  DOCUMENTS_PATHS,
  HOME_BO,
  IMAGES_PATHS,
  INSPECTIONS_PATHS,
  STRUCTURES_PATHS,
} from './paths';

/**
 * this array should contain all of the paths where
 * the "macro" button on the sidebar should be rendered
 */
export const tour_paths = [
  HOME_BO,
  STRUCTURES_PATHS.STRUCTURES_LIST,
  STRUCTURES_PATHS.STRUCTURE_DETAIL,
  STRUCTURES_PATHS.INSPECTIONS_ARCHIVE,
  INSPECTIONS_PATHS.INSPECTIONS_LIST,
  DOCUMENTS_PATHS.DOCUMENTS_LIST,
  IMAGES_PATHS.IMAGES_LIST,
  COLLABORATORS_PATHS.EDIT_EXTERNAL_COLLBAORATOR,
  COLLABORATORS_PATHS.EDIT_INTERNAL_COLLBAORATOR,
  STRUCTURES_PATHS.INSPECTION_EDIT,
  STRUCTURES_PATHS.INSPECTION_VIEW,
  COLLABORATORS_PATHS.ROOT,
];
/**
 * Home Page - Macro Tour
 */

export const tour_01 = {
  step_01: 'tour-01-section-home-step-01',
  step_02: 'tour-01-section-home-step-02',
  step_02b: 'tour-01-section-home-step-02-b',
  step_02c: 'tour-01-section-home-step-02-c',
  step_03: 'tour-01-section-home-step-03',
  step_04: 'tour-01-section-home-step-04',
};
/**
 * Lista Ponti - Macro Tour
 */
export const tour_02 = {
  step_01: 'tour-02-section-bridges-step-01',
  step_02: 'tour-02-section-bridges-step-02',
  step_02b: 'tour-02-section-bridges-step-02b',
  step_03: 'tour-02-section-bridges-step-03',
  // Guida al primo accesso, Sezione Ponti — nuovo step "Bollini Card ponte"
  // (Tag 5), inserito prima dell'ultimo step "Tasto Nuova Opera" (ora
  // step_05, era step_04).
  step_04: 'tour-02-section-bridges-step-04',
  step_05: 'tour-02-section-bridges-step-05',
};
/**
 * Dettaglio Ponte - Macro Tour
 */
export const tour_03 = {
  step_01: 'tour-03-section-bridge-detail-step-01',
  step_02: 'tour-03-section-bridge-detail-step-02',
  step_03: 'tour-03-section-bridge-detail-step-03',
  step_04: 'tour-03-section-bridge-detail-step-04',
};
/**
 * Pannello Nuova Ispezione - Micro Tour
 */
export const tour_04 = {
  step_01: 'tour-04-section-drawer-new-inspection-step-01',
};
/**
 * Archivio Ispezioni - Macro Tour
 */
export const tour_05 = {
  // Guida al primo accesso, Archivio ispezioni singolo ponte — nuovo primo
  // step "Livelli e Tipologia attività" (colonne omonime della tabella),
  // il vecchio (unico) step "Pulsanti" passa a step_02.
  step_01: 'tour-05-section-inspections-archive-step-01',
  step_02: 'tour-05-section-inspections-archive-step-02',
};
/**
 * Modifica Ispezione - Macro Tour
 */
export const tour_06 = {
  step_01: 'tour-06-section-edit-inspection-step-01',
  step_02: 'tour-06-section-edit-inspection-step-02',
  step_03: 'tour-06-section-edit-inspection-step-03',
  step_04: 'tour-06-section-edit-inspection-step-04',
  step_05: 'tour-06-section-edit-inspection-step-05',
};
export const tour_06a = {
  step_01: 'tour-06a-section-view-inspection-step-01',
};
/**
 * Pannelo upload media getsione tag - Micro Tour
 */
export const tour_07 = {
  step_01: 'tour-07-section-upload-media-step-01',
};
/**
 * Sezione L0/Contesto/Informazioni Generali - Micro Tour
 */
export const tour_08 = {
  step_01: 'tour-08-section-l0-contesto-informazionigenerali-step-01',
};
/**
 * Sezione L0/Struttura/ Caratteristiche Geometriche - Micro Tour
 */
export const tour_09 = {
  step_01: 'tour-09-section-l0-struttura-caratteristiche-geometriche-step-01',
  step_02: 'tour-09-section-l0-struttura-caratteristiche-geometriche-step-02',
  step_03: 'tour-09-section-l0-struttura-caratteristiche-geometriche-step-03',
};
/**
 * Sezione L0/Struttura/ Caratteristiche Strutturali - Micro Tour
 */
export const tour_10 = {
  step_01: 'tour-10-section-l0-struttura-caratteristiche-strutturali-step-01',
  step_02: 'tour-10-section-l0-struttura-caratteristiche-strutturali-step-02',
};
/**
 * Sezione L0>Struttura>Collegamenti>Copia- Micro Tour
 */
export const tour_11 = {
  step_01: 'tour-11-section-l0-struttura-collegamenti-step-01',
};
/**
 * Sezione L0/Elementi Accessori/ Caratteristiche Elementi Accessori - Micro Tour
 */
export const tour_12 = {
  step_01:
    'tour-12-section-l0-elementi-accessori-caratteristiche-elementi-accessori-step-01',
};
/**
 * Sezione L1>Struttura>Elevazione>Copia- Micro Tour
 */
export const tour_13 = {
  step_01: 'tour-13-section-l1-struttura-elevazione-step-01',
};
export const tour_13a = {
  step_02: 'tour-13a-section-l1-struttura-elevazione-step-02',
};

export const tour_13pile = {
  step_01: 'tour-13pile-section-l1-struttura-elevazione-step-01',
};
export const tour_13a_pile = {
  step_02: 'tour-13a_pile-section-l1-struttura-elevazione-step-02',
};
/**
 * Sezione Ispezioni - Macro Tour
 */
export const tour_14 = {
  step_01: 'tour-14-section-inspections-list-step-01',
  // Guida al primo accesso, Sezione Attività — nuovo step "Livelli e
  // Tipologia attività", inserito subito dopo "Filtri" (step_01). Il vecchio
  // step_02 ("Modifica/Blocca/Condividi") passa a step_03.
  step_02: 'tour-14-section-inspections-list-step-02',
  step_03: 'tour-14-section-inspections-list-step-03',
};
/**
 * Sezione Documenti - Macro Tour
 */
export const tour_15 = {
  step_01: 'tour-15-section-documents-list-step-01',
  step_02: 'tour-15-section-documents-list-step-02',
};
/**
 * Sezione Immagini - Macro Tour
 */
export const tour_16 = {
  step_01: 'tour-16-section-images-list-step-01',
  step_02: 'tour-16-section-images-list-step-02',
};
/**
 * Sezione Modifica Collaboratore Interno/Esterno - Macro Tour
 */
export const tour_17 = {
  step_01: 'tour-17-section-edit-collaborator-step-01',
  step_02: 'tour-17-section-edit-collaborator-step-02',
};
/**
 * Sezione Lista Collaboratorio - Macro Tour
 */
export const tour_17a = {
  step_01: 'tour-17a-section-edit-collaborator-step-01',
};
/**
 * Modifica Ispezione L3 Idraulico - Macro Tour (Guida al primo accesso,
 * Excel "ID SCHERMATA" 18: "Schermata modifica L3 idraulico") — tour
 * alternativo a tour_06, mostrato al posto di quello quando l'attività
 * aperta in modifica è di tipo L3 (vedi CreateInspection.jsx). step_03/
 * step_04 sono su elementi condivisi con tour_06 (Condivisione ispezione,
 * Salva/Archivia — HeaderPage.jsx/CreateInspection.jsx, invariati per
 * livello), affiancati come classi indipendenti sugli stessi nodi DOM.
 */
export const tour_18 = {
  step_01: 'tour-18-section-edit-inspection-l3-step-01',
  step_02: 'tour-18-section-edit-inspection-l3-step-02',
  step_03: 'tour-18-section-edit-inspection-l3-step-03',
  step_04: 'tour-18-section-edit-inspection-l3-step-04',
};
// tour_18, step "Livelli 0,1,2" — le tab L0/L2 sono <StyledTab> distinte,
// reactour evidenzia un solo elemento per selettore: marker puri (non la
// classe del tour) sulle due tab di bordo del gruppo, misurati da
// <MutedLevelsTourHighlight/> (TabCreateInspection.jsx) per evidenziare
// l'intero gruppo L0→L2 — stesso problema/soluzione già usata in
// InspectionsArchive.jsx per le colonne Livelli/Tipologia attività. Qui in
// constants/tour.js (non in TabCreateInspection/costants.js, che importa
// già TabCreateInspection.jsx: ci sarebbe un import circolare).
export const TOUR_18_MUTED_LEVELS_START = 'tour-18-muted-levels-start';
export const TOUR_18_MUTED_LEVELS_END = 'tour-18-muted-levels-end';
